module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen",
    attrs: {
      "id": "channellist"
    }
  }, [_c('div', {
    attrs: {
      "id": "groups"
    }
  }, [_c('ul', _vm._l((_vm.groups), function(group) {
    return _c('li', {
      key: group.id,
      staticClass: "group",
      style: ({
        'background-color': group.color
      }),
      on: {
        "click": function($event) {
          return _vm.toGroup(group.id)
        }
      }
    }, [_c('div', [_vm._v("\n                    " + _vm._s(group.name) + "\n                ")])])
  }), 0)]), _vm._v(" "), _c('Channels', {
    attrs: {
      "filters": _vm.filters,
      "filteredChannels": _vm.filteredChannels
    },
    on: {
      "openChannel": _vm.openChannel,
      "apiGetChannelList": _vm.apiGetChannelList,
      "clearSearch": _vm.clearSearch
    }
  }), _vm._v(" "), _c('Epg', {
    attrs: {
      "formattedDate": _vm.formattedDate,
      "archiveProgramInfo": _vm.archiveProgramInfo
    },
    on: {
      "epgPrevDay": _vm.epgPrevDay,
      "epgNextDay": _vm.epgNextDay,
      "openProgram": _vm.openProgram
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-179d6f4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChannelList.vue
// module id = 88
// module chunks = 0